<template>
  <div >

    <table class="table table-responsive">
      <thead >
        <tr>
          <th scope="col">Rank</th>
          <th scope="col">Name</th>
          <th scope="col">Skill</th>
          <th scope="col">Accuracy</th>
          <th scope="col">Odds</th>
          <th scope="col">Min</th>
          <th scope="col">Max</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(horse, i) in horses" class="clickable" @click="horseSelected(horse)">
          <td>{{i + 1}}</td>
          <td>{{horse.name}}</td>
          <td>{{horse.skill.toFixed(2)}}</td>
          <td>{{horse.accuracy? horse.accuracy.toFixed(2): '?'}}</td>
          <td>{{horse.oddsNumber? horse.oddsNumber.toFixed(2) : '?'}}</td>
          <td>{{horse.skillObj? horse.skillObj.minSkill.toFixed(2) : '?'}}</td>
          <td>{{horse.skillObj? horse.skillObj.maxSkill.toFixed(2) : '?'}}</td>
        </tr>
      </tbody>
    </table>

  </div>
</template>

<script>
export default {
  name: 'HorseScoresTable',
  props:   {
    horses: Array
  },
  components: {
  },
  data () {
    return {
    }
  },
  watch: {
  },
  methods: {
    horseSelected: function(horse) {
      this.$emit("horseSelected", horse)
    }
  },
  mounted () {
    console.log(this.horses)
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#nameCell {
  font-size: 10pt
}

.green {
  background-color: green
}
</style>
